const loanPurposes = [
  {
    value: 'pay_other_debts',
    text:  'Pagar Outras Dívidas',
  },
  {
    value: 'pay_bills',
    text:  'Pagar Contas',
  },
  {
    value: 'shopping',
    text:  'Fazer Compras',
  },
  {
    value: 'home_payment',
    text:  'Reformar a Casa ou Pagar Mudança',
  },
  {
    value: 'car_payment',
    text:  'Comprar ou Consertar um Carro',
  },
  {
    value: 'medical_payment',
    text:  'Tratamento Médico',
  },
  {
    value: 'new_business',
    text:  'Começar um Novo Negócio',
  },
  {
    value: 'help_a_family_member',
    text:  'Ajudar uma outra Pessoa da Família',
  },
  {
    value: 'other',
    text:  'Outros',
  },
];
export default loanPurposes;
